import cn from 'classnames';
import { useLogger } from '@packages/shared/core/common/hooks';

import styles from './CountryFlag.module.scss';

type CountryFlagProps = {
  className?: string;
  code?: string;
};

const CountryFlag = ({ code = '', className = '' }: CountryFlagProps) => {
  const normalizedCode = code.trim().toLowerCase();

  const particularFlagClass = styles[`flag_${normalizedCode}`];

  const logger = useLogger();

  if (!particularFlagClass) {
    logger.warn(`Flag ${code} not found`);
  }

  return (
    <div className={cn(styles.flag, className)}>
      <span className={styles.flagPlaceholder} />

      <span className={cn(styles.flagImage, particularFlagClass)} />
    </div>
  );
};

export default CountryFlag;
